<template>

    <div class="container">

        <div class="intro" v-bind:style="{ backgroundImage: image_url() }">

            <div class="overlay">

                <div class="wrapper">
                    <p class="subline">LATEST</p>
                    <h1 class="headline">NEWS</h1>

                    <p class="keywords">
                        Stay updated on our latest news, our team and<br>
                        our projects
                    </p>

                    <a class="anim_button" @click="scrollPageHeight()">
                        <p>SEE MORE INFO</p>
                        <div class="span_bg"></div>
                    </a>

                </div>

                <div class="bottom__bar">

                    <div class="text-wrap">
                        <p class="red_text">LATEST</p>
                        <p class="regular_text">NEWS</p>
                        <p class="red_text second">00</p>
                    </div>

                </div>

            </div>

        </div>

        <template v-if="news.length > 0 || featured.length > 0">
            <news-showcase :news="news" :featured="featured"></news-showcase>
        </template>

        <template v-if="latest">
            <news-article :news="latest"></news-article>
        </template>

    </div>

</template>
<script>
    export default {
        data(){
            return {
                text: "Vue3 component."
            }
        },
        props: ['news', 'featured', 'latest', 'hero_image'],
        methods: {
            scrollPageHeight(){
                const height = window.innerHeight - document.getElementsByTagName('header')[0].clientHeight;
                window.scrollBy(0, height);
            },

            image_url(){
                return "url('" + this.hero_image.media_URL + "')"
            }
        }
    }
</script>
<style lang="scss" scoped>



    .container{

        .intro{
            position: relative;
            height: 100vh;

            // background: url('/images/news/page_header.webp');
            background-repeat: no-repeat;
            // background-position: center -140px;
            // background-position: -40px center;
            background-position: center;
            background-size: cover;
            background-color: black;

            .overlay{
                display: block;
                width: 100%;
                height: 100%;
                position: relative;

                background: rgba(92, 44, 144, 0.6);

                .wrapper{
                    display: block;
                    position: absolute;
                    top: 57%; right: 50%;
                    transform: translate(50%, -50%);
                    // width: 976px;
                    width: 100%;
                    // max-width: 1020px;
                    max-width: 450px;
                    height: auto;

                    .subline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 50px;
                        line-height: 60px;
                        /* identical to box height */

                        text-align: center;

                        color: #ED1163;
                        margin: 0;
                        text-align: left;
                    }

                    .headline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 700;
                        font-size: 175px;
                        line-height: 175px;
                        /* identical to box height */

                        color: #FFFFFF;
                        margin: 0;

                        margin-left: -5px;
                    }

                    .keywords{
                        font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-size: 22px;
                        line-height: 30px;
                        /* or 136% */

                        margin: 0;
                        margin-top: 22px;
                        text-align: center;
                        width: 100%;
                        max-width: 454px;
                        margin-left: auto;
                        margin-right: auto;

                        color: #FFFFFF;
                    }

                    a.anim_button{
                        display: block;
                        background: rgba(15, 15, 15, 0.3);
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                        width: 409px;
                        height: 50px;
                        margin-bottom: -9px;
                        cursor: pointer;
                        user-select: none;
                        position: relative;
                        overflow-y: hidden;
                        z-index: 4;
                        text-decoration: none;
                        margin-top: 93px;
                        margin-left: auto;
                        margin-right: auto;

                        p{
                            font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 700;
                            font-size: 20px;
                            line-height: 54px;
                            text-align: center;
                            letter-spacing: 0.2em;
                            text-transform: uppercase;
                            margin: 0 auto;

                            color: #FFFFFF;
                            position: relative;
                            z-index: 4;
                        }

                        div.span_bg{
                            background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                            height: 100%;
                            width: 100%;
                            transition: all .3s ease-in-out;
                            margin-top: auto;
                            margin-bottom: 0;
                            opacity: 0;

                            position: absolute;
                            bottom: -50px;
                            z-index: 3;
                        }

                        &:hover{
                            div.span_bg{
                                height: calc(100%);
                                bottom: 0;
                                opacity: 1;
                            }
                        }
                    }
                }

                .bottom__bar{
                    background: linear-gradient(360deg, #1A1A1A -0.25%, #222222 100%);
                    height: 64px;
                    width: 100%;
                    position: absolute;
                    bottom: 0;

                    border-top: 1px solid #ED1163;
                    border-bottom: 1px solid #ED1163;

                    .text-wrap{
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        position: relative;
                        margin-top: 20px;

                        .red_text{
                            font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-size: 25px;
                            line-height: 25px;
                            /* or 100% */

                            color: #ED1163;
                            margin: 0;

                            &.second{
                                margin-left: 24px;
                            }
                        }

                        .regular_text{
                            font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-size: 25px;
                            line-height: 25px;
                            /* or 100% */

                            color: #ffffff;
                            margin: 0;
                            margin-left: 8px;
                        }
                    }

                    
                }
            }
        }
    }


    
    @media screen and (max-width: 836px) {

        .container{

            .intro{
                
                .overlay{

                    .wrapper{
                        width: 100%;

                        .subline{
                            font-size: 20px;
                            line-height: 24px;
                            text-align: center;
                            margin-bottom: 15px;
                        }

                        .headline{
                            font-size: 40px;
                            line-height: 40px;
                            text-align: center;
                        }

                        .keywords{
                            font-size: 16px;
                            line-height: 16px;
                        }

                        a.anim_button{
                            width: 100%;
                            max-width: 245px;
                            height: 35px;
                            
                            p{
                                font-size: 12px;
                                line-height: 40px;
                            }
                        }
                    }

                    .bottom__bar{
                        .text-wrap{
                            .red_text, .regular_text, .red_text.second{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-size: 18px;
                                line-height: 25px;
                            }   
                        }
                    }
                }
            }
        }
    }

</style>